import AntSpin, { SpinProps as AntSpinProps } from 'antd/lib/spin';

interface SpinProps extends AntSpinProps {}

export const Spin = (props: SpinProps) => <AntSpin {...props} />;
